export const SPACE_UNITS = {
    small: 8,
    medium: 16,
    mediumPlus: 22,
}